import { useMutation, useQuery } from 'react-query';
import queryGetMerchantAccountPayluddSubscriptions from './queries/getMerchantAccountPayluddSubscriptions';
import queryGetPayluddSubscriptions from './queries/getPayluddSubscriptions';
import queryGetEmergencyRemoteCollection from './queries/getEmergencyRemoteCollection';
import mutationTriggerEmergencyRemoteCollection from './mutations/triggerEmergencyRemoteCollection';
import mutationSummarizeEmergencyRemoteCollectionTransactions from './mutations/summarizeEmergencyRemoteCollectionTransactions';


const actionsPayluddSubscriptions = {
    // Get all payludd subscriptions
    getPayluddSubscriptions: (query, enabled = true) => useQuery(queryGetPayluddSubscriptions(query, enabled)),
    // Get merchant account payludd subscriptions
    getMerchantAccountPayluddSubscriptions: (params, enabled) => useQuery(queryGetMerchantAccountPayluddSubscriptions(params, enabled)),

    // Get emergency remote collection
    getEmergencyRemoteCollection: (params) => useQuery(queryGetEmergencyRemoteCollection(params)),
    // Summarize emergency remote collection transactions
    summarizeEmergencyRemoteCollectionTransactions: (params) => useMutation(mutationSummarizeEmergencyRemoteCollectionTransactions(params)),
    // Trigger emergency remote collection
    triggerEmergencyRemoteCollection: (params) => useMutation(mutationTriggerEmergencyRemoteCollection(params))
};

export default actionsPayluddSubscriptions;